/* eslint-disable camelcase */
import React from 'react';

const Picture = ({ image }) => {
  const {
    src,
    width,
    height,
    class: imgClass,
    alt,
    title,
    srcset_webp,
    srcset,
    loading,
  } = image;

  return (
    <picture className={imgClass} alt={alt} title={title}>
      <source
        data-srcset={srcset_webp}
        data-sizes="auto"
        type="image/webp"
        srcSet={srcset_webp}
      />

      <source
        data-srcset={srcset}
        data-sizes="auto"
        type="image/jpeg"
        srcSet={srcset}
      />

      <img
        src={src}
        className={imgClass}
        alt={alt}
        title={title}
        width={width}
        height={height}
        loading={loading}
      />
    </picture>
  );
};

export default Picture;
